import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import { courseCategoryLandingPageStatus } from 'reduxModules/courseCategoryLandingPage'
import { courseCategoryLandingPageStateSelector as stateSelector } from 'reduxModules/courseCategoryLandingPage/selectors'
import { courseCategoryLandingPageDispatchers as dispatchers } from 'reduxModules/courseCategoryLandingPage/dispatchers'
import withRouterV6 from '../../utils/withRouterV6'

import ItemResultPropTypes from '../NewSearch/propTypes'
import { TagPropTypes } from '../NewSearch/Tag'
import SubscribeDialogCTA from '../App/SubscribeDialogCTA'
import NewSearch from '../NewSearch/index'

import './styles.css'

export class CourseCategoryLandingPage extends Component {
  componentDidMount() {
    this.props.loadCourseCategoryLandingPage()
  }

  componentWillUnmount() {
    this.props.clearCourseCategory()
  }

  render() {
    if (this.props.status !== courseCategoryLandingPageStatus.success) return null

    const metaTitle = this.props.metaTitle || this.props.title
    const metaDescription = this.props.metaDescription || this.props.description

    return (
      <div id="CourseCategoryLandingPage">
        <Helmet>
          <title>{metaTitle} | Stan Winston School of Character Arts</title>
          <meta name="description" content={metaDescription} />
          <meta property="og:title" content={metaTitle} />
          <meta property="og:description" content={metaDescription} />
          {this.props.facebookShareImages.length > 0 && this.props.facebookShareImages.map((fbImage, fbImageIndex) => (
            <meta property="og:image" content={fbImage.original} key={fbImageIndex} />
          ))}
          <meta content="article" property="og:type" />
        </Helmet>
        <section id="banner" style={{ backgroundImage: `url(${this.props.isMobile ? '' : this.props.photo.default})` }}>
          <div className="title-description wrapper">
            <h1>{this.props.title}</h1>
            <p>{this.props.description}</p>
            {!this.props.hasSubscription && !this.props.usedFreeTrial && (
              <SubscribeDialogCTA>
                <div className="btn -orange">
                  <span>{this.props.usedFreeTrial ? 'Subscribe' : 'Start My Free Trial'}</span>
                </div>
              </SubscribeDialogCTA>
            )}
          </div>
        </section>
        <section id="content">
          <NewSearch embeddedFetchQuery={this.props.slug} />
        </section>
      </div>
    )
  }
}

export const CourseCategoryLandingPagePropType = {
  // --
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  socialUrl: PropTypes.string.isRequired,
  // --
  metaDescription: PropTypes.string,
  metaKeywords: PropTypes.string,
  metaTitle: PropTypes.string,
  // --
  id: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  photo: PropTypes.shape({
    original: PropTypes.string.isRequired,
    default: PropTypes.string.isRequired
  }),
  facebookShareImages: PropTypes.arrayOf(
    PropTypes.shape({
      default: PropTypes.string.isRequired,
      thumb: PropTypes.string.isRequired,
      facebook: PropTypes.string.isRequired,
      original: PropTypes.string.isRequired
    })
  )
}

CourseCategoryLandingPage.propTypes = {
  // from selectors
  ...CourseCategoryLandingPagePropType,
  status: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  hasSubscription: PropTypes.bool,
  usedFreeTrial: PropTypes.bool,
  searchSelectors: PropTypes.shape({
    loading: PropTypes.number.isRequired,
    tags: PropTypes.arrayOf(PropTypes.shape(TagPropTypes)).isRequired,
    results: PropTypes.arrayOf(PropTypes.shape(ItemResultPropTypes)).isRequired,
    status: PropTypes.string.isRequired,
    active: PropTypes.string.isRequired,
    categories: PropTypes.arrayOf(PropTypes.string).isRequired
  }).isRequired,
  // from dispatchers
  closeBannerSubscription: PropTypes.func.isRequired,
  loadCourseCategoryLandingPage: PropTypes.func.isRequired,
  searchDispatchers: PropTypes.shape({
    getResults: PropTypes.func.isRequired,
    selectCategory: PropTypes.func.isRequired,
    clearResults: PropTypes.func.isRequired
  }).isRequired
}

CourseCategoryLandingPage.defaultProps = {
  isMobile: false,
  hasSubscription: false,
  usedFreeTrial: false,
  metaDescription: '',
  metaKeywords: '',
  metaTitle: ''
}

export default withRouterV6(connect(stateSelector, dispatchers)(CourseCategoryLandingPage))
